const inputArraySelect = (editor) => {
  editor.BlockManager.add('arrayInputSelect', {
    label: `
            <svg class="svg-icon" style="width: 1em; height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M576 1024v-128h128V128h-128V0h256v1024H576zM192 960V0h256v128h-128v768h128v128H192v-64z" fill="" /></svg>
              <div class='gjs-fontFamily gjs-fontFamily'>Array Input Select</div>
        `,
    category: 'Forms ',
    content: `<div arrayInput="true">
                <ul panelToShowInput="true"></ul>
                <div style="display:flex">
                  <select class="form-select" aria-label="Default select example" inputElement="true">
                                        <option selected>Open this select menu</option>
                                        <option dataitem=true value="1">One</option>
                                        <option dataitem=true value="2">Two</option>
                                        <option dataitem=true value="3">Three</option>
                  </select>
                  <button class="btn btn-primary" style="margin-left: 10px" addToPanel="true" >Add </button>
                </div>
              </div>`,
    attributes: { inputarray: 'true' }
  });
};

export default inputArraySelect;
